import { isPlatformBrowser } from '@angular/common';

export function loadGitlabVisualReview(
  config: {
    projectId: string;
    mergeRequestId: string;
    mergeRequestURL: string;
    projectPath: string;
  },
  platformId: object
) {
  if (isPlatformBrowser(platformId)) {
    const script = document.createElement('script');
    script.src = 'https://gitlab.com/assets/webpack/visual_review_toolbar.js';
    script.setAttribute('data-project-id', config.projectId);
    script.setAttribute('data-merge-request-id', config.mergeRequestId);
    script.setAttribute('data-project-path', config.projectPath);
    script.setAttribute('data-mr-url', 'https://gitlab.com');
    script.setAttribute('id', 'review-app-toolbar-script');
    document.head.appendChild(script);
  }
}
